import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3401afba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zk" }
const _hoisted_2 = { class: "zk_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "转入车间/仓库", -1))
const _hoisted_4 = { class: "zk_list_item_n" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "货位", -1))
const _hoisted_6 = { class: "zk_list_item_n" }
const _hoisted_7 = { class: "zk_title" }
const _hoisted_8 = { class: "zk_title_left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zk_title_i" }, null, -1))
const _hoisted_10 = { class: "zk_title_right" }
const _hoisted_11 = { class: "zk_wl" }
const _hoisted_12 = { class: "zk_wl_item" }
const _hoisted_13 = {
  key: 1,
  class: "zk_wl_w"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zk_z" }, null, -1))
const _hoisted_17 = { class: "zk_footer" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20px"} }, null, -1))

import { reactive, ref, onMounted, watch } from 'vue'
    import { Toast } from 'vant'
    import { useRouter, useRoute } from "vue-router"
    import { getListByCondition, getListByWarehouseId, getBarcodeContent, scanTransfer } from '@/apis/WorkOrderAPI'
    import { QRCodeType, Attribute } from "@/enum"
    import Warehouse from '@/components/common/Warehouse.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()
    const route = useRoute()

    const openCodea = ref<boolean>(false)  // 控制扫码显示隐藏
    let list: any = ref([])  // 转出工装列表
    let locationData: any = ref([])  // 货位数据
    let isShow = ref(false) // 控制货位选择显示隐藏
    let total = ref(0)  // 总计数量
    let customFieldName = {  // 自定义下拉选项显示文字
        text: 'area'
    }

    let data = reactive({
        type: '',

        warehouseName: '',
        warehouseId: '',
        locationName: '',
        locationId: ''
    })

    let view = reactive({
        type: false,
        Warehouse: false
    })

    // 创建转库单
    const submit = () => {
        if (!data.warehouseId) return Toast.fail({ message: '入库车间/仓库不能为空' })
        if (isShow.value && !data.locationId) return Toast.fail({ message: '货位不能为空' })
        let idList = list.value.map((item: any) => {
            return item.id
        })
        scanTransfer({
            idList,
            inLocationId: data.locationId,
            inWarehouseId: data.warehouseId,
            outWarehouseId: list.value[0].warehouseId
        }).then(res => {
            if (res.code === 200) {
                Toast.success({ message: '转库成功', duration: 2000, forbidClick: true })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 扫码回调
    const onDecodea = async (datav: string[]): Promise<void> => {
        getBarcodeContent({
            barcode: datav[0]
        }).then(res => {
            if (res.code === 200) {
                if (res.data.barcodeType === QRCodeType.GZ) {   // 判断是否是工装码
                    getListByCondition({ id: res.data.id })
                        .then(res => {
                            if (res.code === 200) {
                                if (res.data && res.data.length > 0) {    // 判断是否查询到工装
                                    let next: boolean = true
                                    list.value.forEach((element: any) => {  // 判断是否有重复的工装
                                        if (element.id === res.data[0].id) {
                                            next = false
                                        }
                                    })
                                    if (!next) {
                                        Toast.fail({ message: '不能重复添加相同的工装' })
                                        return
                                    }
                                    if (res.data[0].status !== 1) {    // 判断工装是否为空
                                        if (res.data[0].warehouseId) {  // 判断工装是否在仓库下
                                            if (res.data[0].warehouseId === list.value[0].warehouseId) {    // 判断仓库是否一致
                                                if (res.data[0].smodelLabel === list.value[0].smodelLabel) {    // 属性是否一致
                                                    if (res.data[0].locationId !== data.locationId) {
                                                        list.value.push(res.data[0])
                                                    } else {
                                                        Toast.fail({ message: '货位不能一致', duration: 2000 })
                                                    }
                                                } else {
                                                    Toast.fail({ message: '属性不一致', duration: 2000 })
                                                }
                                            } else {
                                                Toast.fail({ message: '工装仓库不一致', duration: 2000 })
                                            }
                                        } else {
                                            Toast.fail({ message: '该工装不在仓库', duration: 2000 })
                                        }
                                    } else {
                                        Toast.fail({ message: '该工装状态为空', duration: 2000 })
                                    }
                                } else {
                                    Toast.fail({ message: '未查询到工装', duration: 2000 })
                                }
                            }
                        })
                } else {
                    Toast.fail({ message: '请扫描正确的工装码', duration: 2000 })
                }
            }
        }).finally(() => {
            openCodea.value = false
        })
    }

    // 关闭扫码组件
    const closePopupa = (): void => {
        openCodea.value = false
    }

    // 删除物料
    const dele = (i: number): void => {
        if (list.value.length === 1) {
            Toast.fail({ message: '至少保留一项工装' })
            return
        }
        list.value.splice(i, 1)
    }

    // 仓库回调
    const getValue = async (val: any): Promise<void> => {
        if (val.id === list.value[0].warehouseId) {
            data.warehouseId = val.id;
            data.warehouseName = val.name;
            if (val.useLocation === 1) {
                await getLocation(val.id)
                isShow.value = true
            } else {
                isShow.value = false
            }
        } else {
            locationData.value = []
            data.locationName = ''
            data.locationId = ''
            if (list.value[0].smodelLabel === Attribute.HH || val.tmodel.label === Attribute.HH) {   // 混合 可以选择任意仓库
                data.warehouseId = val.id;
                data.warehouseName = val.name;
            } else if (list.value[0].smodelLabel === val.tmodel.label) {    // 判断属性是否一致
                data.warehouseId = val.id;
                data.warehouseName = val.name;
            } else {
                Toast.fail({ message: '工装的质量属性和仓库属性不相符' })
            }
            isShow.value = false
        }
        view.Warehouse = false;
    }

    // 打开选择弹框
    const open = (type: string): void => {
        if (type === 'r') {
            view.Warehouse = true
        } else if (type === 'h') {
            view.type = true
        } else if (type === 'code') {
            if (!data.warehouseId) {
                Toast.fail({ message: '仓库不能为空' })
                return
            }
            if (isShow.value && !data.locationId) {
                Toast.fail({ message: '货位不能为空' })
                return
            }
            openCodea.value = true
        }
    }

    // 确认货位
    const onConfirm = (val: any): void => {
        if (list.value[0].smodelLabel === Attribute.HH || val.label === Attribute.HH) {   // 混合 可以选择任意仓库
            if (list.value[0].locationId === val.id) {
                Toast.fail({ message: '货位不能一致' })
                return
            }
            data.locationId = val.id
            data.locationName = val.area
        } else if (list.value[0].smodelLabel === val.label) {    // 判断属性是否一致
            if (list.value[0].locationId === val.id) {
                Toast.fail({ message: '货位不能一致' })
                return
            }
            data.locationId = val.id
            data.locationName = val.area
        } else {
            Toast.fail({ message: '工装和货位属性不一致' })
        }
        view.type = false
    }

    // 关闭货位弹框
    const onCancel = (): void => {
        view.type = false
    }

    // 获取工装信息
    const getGZInfo = (id: string): void => {
        getListByCondition({ id })
            .then(res => {
                if (res.code === 200 && res.data.length > 0) {
                    list.value.push(res.data[0] as never)
                }
            })
    }

    // 根据仓库获取货位信息
    const getLocation = (id: string): void => {
        getListByWarehouseId({
            wareHouseId: id
        }).then(res => {
            if (res.code === 200) {
                if (res.data && res.data.length > 0) {
                    locationData.value = res.data
                }
            }
        })
    }

    // 监听工装数组，计算总数
    watch(() => list.value, () => {
        if (list.value.length > 0) {
            total.value = 0
            list.value.forEach((element: any) => {
                total.value = total.value + element.num
            })
        }
    }, { deep: true, immediate: true })

    onMounted(() => {
        getGZInfo(route.query.id as string)
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "zk_list_item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open('r')))
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              style: _normalizeStyle(_unref(data).warehouseName ? 'color: black;' : '')
            }, _toDisplayString(_unref(data).warehouseName ? _unref(data).warehouseName : '请选择'), 5),
            _createVNode(_component_van_icon, {
              name: "arrow",
              color: "#999999",
              size: "20"
            })
          ])
        ]),
        (_unref(isShow))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "zk_list_item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (open('h')))
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  style: _normalizeStyle(_unref(data).locationName ? 'color: black;' : '')
                }, _toDisplayString(_unref(data).locationName ? _unref(data).locationName : '请选择'), 5),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  color: "#999999",
                  size: "20"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, "转出工装列表(" + _toDisplayString(_unref(list).length) + ")", 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, "总计：" + _toDisplayString(_unref(total)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_unref(list).length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(list), (item, i) => {
              return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: i }, {
                right: _withCtx(() => [
                  _createVNode(_component_van_button, {
                    square: "",
                    type: "danger",
                    style: {"height":"100%"},
                    text: "删除",
                    onClick: ($event: any) => (dele(i))
                  }, null, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(item.code) + " " + _toDisplayString(item.num) + _toDisplayString(item.umodelName), 1),
                    _createElementVNode("span", null, "物料信息：" + _toDisplayString(item.mmodelName) + " | " + _toDisplayString(item.mmodelCode), 1),
                    _createElementVNode("span", null, "批次号：" + _toDisplayString(item.batch), 1),
                    _createElementVNode("span", null, "生产工序：" + _toDisplayString(item.pmodelName), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "zk_footer_wl",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (open('code')))
        }, "继续扫码"),
        _hoisted_18,
        _createElementVNode("div", {
          class: "zk_footer_submit",
          onClick: submit
        }, "提交")
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(view).type,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_unref(view).type) = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择货位",
          columns: _unref(locationData),
          onConfirm: onConfirm,
          onCancel: onCancel,
          "columns-field-names": _unref(customFieldName)
        }, null, 8, ["columns", "columns-field-names"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Warehouse, {
      show: _unref(view).Warehouse,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(view).Warehouse = false)),
      onValue: getValue
    }, null, 8, ["show"]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCodea.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopupa,
      onOnDecode: onDecodea
    }, null, 8, ["openCode"])
  ], 64))
}
}

})